import { actions } from 'actions';

export const setProgressRate = (progressRate, num, total) => {
  return (dispatch) => {
    dispatch({
      type: actions.SET_PROGRESSRATE,
      progressRate: progressRate,
      num: num,     //現状何件アップロードできているか
      total: total, //アップロードファイル数
    });
  };
};


export const clearProgressRate = () => {
  return (dispatch) => {
    dispatch({
      type: actions.CLEAR_PROGRESSRATE,
    });
  };
};